"use client"
/* */
import { jsxs, jsx } from 'react/jsx-runtime';
import * as Aria from 'react-aria-components';
import 'react';
import styles from './Tooltip.module.scss.mjs';
import clsx from 'clsx';

const Tooltip = (props) => {
  const { children, className, ...rest } = props;
  const rootClassName = clsx(styles.tooltip, className);
  return /* @__PURE__ */ jsxs(Aria.Tooltip, { ...rest, className: rootClassName, children: [
    /* @__PURE__ */ jsx(Aria.OverlayArrow, { className: styles.tip, children: /* @__PURE__ */ jsx("svg", { viewBox: "0 0 8 8", children: /* @__PURE__ */ jsx("path", { d: "M0 0 L4 4 L8 0" }) }) }),
    children
  ] });
};

export { Tooltip, Tooltip as default };
//# sourceMappingURL=Tooltip.mjs.map
